import Vitaliy from '../../images/team/Vitalii_Kretsul.jpg';
import Maksym from '../../images/team/Maksym_Stelmakh.jpeg';
import MelnykSerhii from '../../images/team/Melnyk_Serhii.jpg';
import AlinaVikulova from '../../images/team/Alina_Vikulova.jpg';
import YakovHomylev from '../../images/team/Yakov_Homylev.jpg';
import ElenaStepanchuk from '../../images/team/Elena_Stepanchuk.jpeg';
import TetianaHorban from '../../images/team/Tetiana_Horban.jpg';
import DmitrySolyanik from '../../images/team/Dmitry_Solyanik.jpg';
import NataliiaTrushevska from '../../images/team/Nataliia_Trushevska.jpg';
import OlhaKukailo from '../../images/team/Olha_Kukailo.jpg';
import NataliaGalitskaya from '../../images/team/Natalia_Galitskaya.jpg';
import OlhaSuprun from '../../images/team/Olha_Suprun.jpg';
const team = [
  {
    id: 1,
    fullName: 'Vitalii Kretsul',
    position: 'Team Leader',
    photo: `.${Vitaliy}`,
    linkedIn:
      'https://www.linkedin.com/in/%D0%B2%D0%B8%D1%82%D0%B0%D0%BB%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D1%86%D1%83%D0%BB-442213b6/',
    gitHub: 'https://github.com/Kretsul-Vitaliy',
  },
  {
    id: 2,
    fullName: 'Alina Vikulova',
    position: 'Scrum master',
    photo: `.${AlinaVikulova}`,
    linkedIn: 'https://www.linkedin.com/in/alina-vikulova',
    gitHub: 'https://github.com/AliVik',
  },
  {
    id: 3,
    fullName: 'Maksym Stelmakh',
    position: 'Front-end',
    photo: `.${Maksym}`,
    linkedIn: 'https://www.linkedin.com/in/maksstelmakh/',
    gitHub: 'https://github.com/MaksStelmakh',
  },
  {
    id: 4,
    fullName: 'Melnyk Serhii',
    position: 'Back-end',
    photo: `.${MelnykSerhii}`,
    linkedIn: '#',
    gitHub: 'https://github.com/mellsson89',
  },
  {
    id: 5,
    fullName: 'Yakov Homylev',
    position: 'Front-end',
    photo: `.${YakovHomylev}`,
    linkedIn: '#',
    gitHub: 'https://github.com/Yakov-Homylev',
  },
  {
    id: 6,
    fullName: 'Elena Stepanchuk',
    position: 'Front-end',
    photo: `.${ElenaStepanchuk}`,
    linkedIn: 'https://www.linkedin.com/in/elena-stepanchuk/',
    gitHub: 'https://github.com/ElenaStepanchuk',
  },
  {
    id: 7,
    fullName: 'Tetiana Horban',
    position: 'Front-end',
    photo: `.${TetianaHorban}`,
    linkedIn: 'http://linkedin.com/in/tetiana-horban-7b48a221b',
    gitHub: 'https://github.com/Tetiana-Horban',
  },
  {
    id: 8,
    fullName: 'Vladyslav Koval',
    position: 'Front-end',
    photo: `.${YakovHomylev}`,
    linkedIn: '#',
    gitHub: 'https://github.com/Zamder13',
  },
  {
    id: 9,
    fullName: 'Chornoknyzhnyi Oleksii',
    position: 'Back-end',
    photo: `.${YakovHomylev}`,
    linkedIn: '#',
    gitHub: 'https://github.com/DramonBuster',
  },
  {
    id: 10,
    fullName: 'Dmitry Solyanik',
    position: 'QA engineer Team Leader ',
    photo: `.${DmitrySolyanik}`,
    linkedIn: 'https://www.linkedin.com/in/dmitry-solyanik/',
    gitHub: '#',
  },
  {
    id: 11,
    fullName: 'Nataliia Trushevska',
    position: 'QA engineer',
    photo: `.${NataliiaTrushevska}`,
    linkedIn: '#',
    gitHub: '#',
  },
  {
    id: 12,
    fullName: 'Olha Kukailo',
    position: 'QA engineer',
    photo: `.${OlhaKukailo}`,
    linkedIn: 'https://www.linkedin.com/in/olha-kukailo-403460138/',
    gitHub: '#',
  },
  {
    id: 13,
    fullName: 'Natalia Galitskaya',
    position: 'QA engineer',
    photo: `.${NataliaGalitskaya}`,
    linkedIn: 'https://www.linkedin.com/in/natali-galitskaya-suhova-74564684/',
    gitHub: 'https://github.com/Natali-Gal',
  },
  {
    id: 14,
    fullName: 'Olha Suprun',
    position: 'QA engineer',
    photo: `.${OlhaSuprun}`,
    linkedIn: 'https://www.linkedin.com/in/olhasuprun/',
    gitHub: '',
  },
];
export default team;
